// collection Sorting
document.querySelectorAll('.SortByWrapper').forEach((wrapper) => {
  const selected = wrapper.querySelector('.SortBySelected .selected-text');
  const options = wrapper.querySelector('.SortByOptions');
  const items = options.querySelectorAll('li');
  const sortInput = wrapper.querySelector('input[name="sort_by"]');

  const firstItem = items[0];

  if (firstItem) {
    selected.textContent = firstItem.textContent;
    sortInput.value = firstItem.dataset.value;

    items.forEach(item => item.classList.remove('active'));
    firstItem.classList.add('active');
  }

  wrapper.querySelector('.SortBySelected').addEventListener('click', () => {
    const isVisible = options.style.display === 'block';

    document.querySelectorAll('.SortByOptions').forEach(opt => {
      opt.style.display = 'none';
      opt.classList.remove('open'); 
    });

    if (!isVisible) {
      options.style.display = 'block';
      options.classList.add('open');
    }
  });

  items.forEach(li => {
    li.addEventListener('click', () => {
      selected.textContent = li.textContent;
      sortInput.value = li.dataset.value;

      options.style.display = 'none';

      items.forEach(item => item.classList.remove('active'));
      li.classList.add('active');

      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', li.dataset.value);
      window.location.href = url.toString();
    });
  });

  const closeDropdown = (e) => {
    if (!wrapper.contains(e.target)) {
      options.style.display = 'none';
      options.classList.remove('open');
    }
  };

  ['click', 'touchstart'].forEach(evt => {
    document.addEventListener(evt, closeDropdown);
  });
});



// Click handler here
document.addEventListener('click', function (event) {
  const clickedButton = event.target.closest('.custom_filter_btn');
  if (!clickedButton) return;

  // 1. Toggle active class on clicked button
  document.querySelectorAll('.custom_filter_btn').forEach(btn => btn.classList.remove('active'));
  clickedButton.classList.add('active');

  const tag = clickedButton.dataset.tag;
  console.log('Clicked tag:', tag);

  // 2. Uncheck all checkboxes under producttype
  document.querySelectorAll('.producttype .mobile-facets__list li input[data-filter-tag]').forEach(input => {
    if (input.checked) {
      const inputId = input.id;
      const label = document.querySelector(`label[for="${inputId}"]`);
      if (label) {
        label.click(); // Uncheck by clicking label
        console.log('Unchecking:', input.dataset.filterTag);
      }
    }
  });

  // 3. Check the one that matches current tag
  const matchInput = document.querySelector(`.producttype .mobile-facets__list li input[data-filter-tag="${tag}"]`);
  if (matchInput) {
    const inputId = matchInput.id;
    const matchLabel = document.querySelector(`label[for="${inputId}"]`);

    if (!matchInput.checked && matchLabel) {
      matchLabel.click(); // Click label to check
      console.log(' Checked tag:', tag);
    } else {
      console.warn(' Matching input already checked');
    }
  } else {
    console.warn(' Matching input not found');
  }
});

// Auto-trigger on load
// $(document).ready(function () {
//   const $defaultBtn = $('.custom_filter_btn.active').first().length
//     ? $('.custom_filter_btn.active').first()
//     : $('.custom_filter_btn').first();

//   if ($defaultBtn.length) {
//     $defaultBtn.trigger('click');
//   }
// });


document.addEventListener("DOMContentLoaded", function() {
  // Collection card swatches 
   document.addEventListener("click", function(event) {
    const numberShowMore = event.target.closest(".item-swatch-more");
  
    if (!numberShowMore) return;
  
    const swatch = event.target.closest(".card-swatch ul");
    if (!swatch) return;

    const swatchWrapper = swatch.querySelector(".group-swatch");
  
    if (swatch.classList.contains("show--more")) {
      swatchWrapper.style.display = 'none';
      swatch.classList.remove("show--more");
      const span = numberShowMore.querySelector("span");
      if (span) span.textContent = "+";
    } else {
      swatch.classList.add("show--more");
      swatchWrapper.style.display = 'inline';
      const span = numberShowMore.querySelector("span");
      if (span) span.textContent = "-";
    }
  });

  const productCards = document.querySelectorAll(".card-wrapper");

  productCards.forEach((card) => {
    const swatches = card.querySelectorAll(".card-swatch .item");
  
    swatches.forEach((swatch) => {
      swatch.addEventListener('click', function () {
        // Remove 'is-active' only within this card
      
        const clickedLabel = this.querySelector("label.swatch-label");
        if(!clickedLabel) return;
        if(clickedLabel){
          // Add 'is-active' to clicked swatch's label
          swatches.forEach(item => {
            const label = item.querySelector("label.swatch-label");
            if (label) label.classList.remove("is-active");
          });
          if (clickedLabel) clickedLabel.classList.add("is-active");
      
          // Set variant ID in quick-add input
          const variantId = clickedLabel.getAttribute("data-variant-id");
          if (variantId) {
            const input = card.querySelector(".quick-add-wrapper input[name='id']");
            if (input) input.value = variantId;
          }

      
          // Update image
          const variantImg = clickedLabel.getAttribute("data-variant-img");
          const image = card.querySelector(".card__media img");
          if (variantImg && image) {
            image.src = variantImg;
            image.setAttribute("srcset", variantImg);
          }

          const price = clickedLabel.getAttribute("data-price");
          const compare_price = clickedLabel.getAttribute("data-compare-price");

          const discountPercentage = Math.round(((compare_price - price) / compare_price) * 100);
          // console.log("discountPercentage",discountPercentage);
          card.querySelector(".price__label_sale .label_sale").textContent = discountPercentage + "% Off";
          
          const priceFormatted = formatMoney(price, window.moneyFormat);
          const priceNoDecimals = priceFormatted.replace(/\.00$/, "");

          const comparePriceFormatted = formatMoney(compare_price, window.moneyFormat);
          const comparePriceNoDecimals = comparePriceFormatted.replace(/\.00$/, "");

          card.querySelector(".price-item.price-item--regular").textContent = comparePriceNoDecimals;
          card.querySelector(".price-item.price-item--sale").textContent = priceNoDecimals;
    
          // Set button disable or enable
          const checkAvailability = clickedLabel.getAttribute("data-available");
          console.log("checkAvailability",checkAvailability);
          if(checkAvailability == 'false'){
            const quickButton = card.querySelector(".quick-add-wrapper .quick-add__submit");
            quickButton.querySelector(".btn-text").textContent = 'SOLD OUT';
            quickButton.setAttribute('disabled','');
          }else{
            const quickButton = card.querySelector(".quick-add-wrapper .quick-add__submit");
            if(card.closest('section')?.classList.contains('everyday-wrapper')){
              quickButton.querySelector(".btn-text").textContent = 'ADD';
            }else{
              quickButton.querySelector(".btn-text").textContent = 'ADD TO CART';
            }
            quickButton.removeAttribute('disabled');
          }
        }
      });
    });

    const sizeSelector = card.querySelector(".size_options_wrapper");
    
    if(sizeSelector){
      const custom_button = card.querySelector(".quick-add-wrapper.custom-button");
      const default_button = card.querySelector(".quick-add-wrapper.theme-button");
      if(custom_button){
        custom_button.addEventListener('click',function(){
          sizeSelector.classList.remove('hidden');
          this.classList.add('hidden');
          default_button.classList.remove('hidden');
        });
      }
      const sizeOptions = sizeSelector.querySelectorAll('.size_option');
      if(sizeOptions.length){
        sizeOptions.forEach(size_option => {
          size_option.addEventListener('click',function(){
             sizeOptions.forEach(elem => {elem.classList.remove('active')});
            this.classList.add('active');
            const variant_id = size_option.getAttribute("data-variant-id");
            const input = card.querySelector(".quick-add-wrapper input[name='id']");
            if (input) input.value = variant_id;
            const sizeVal = size_option.getAttribute("data-size");
            const selectedValElem = sizeSelector.querySelector(".selected-content .selected-val");
            if(selectedValElem) selectedValElem.textContent = sizeVal;
          });
        });
      }
      const closeBtn = sizeSelector.querySelector(".close_btn_wrapper .close-btn");
      if(closeBtn){
        closeBtn.addEventListener('click',function(){
          sizeSelector.classList.add('hidden');
          custom_button.classList.remove('hidden');
          default_button.classList.add('hidden');
        });
      }
    }
  });

  // Video with product section
  const videoWrappers = document.querySelectorAll('.video-with-product-container .video-box-wrapper');

  videoWrappers.forEach(wrapper => {
    const videoUrl = wrapper.getAttribute('data-video-src');
    const posterUrl = wrapper.getAttribute('data-poster');
    setTimeout(function(){
      
 
    if (videoUrl) {
      const videoEl = document.createElement('video');
      videoEl.setAttribute('loop', true);
      videoEl.setAttribute('autoplay', true);
      videoEl.setAttribute('playsinline', true);
      videoEl.setAttribute('preload', 'none');
      videoEl.setAttribute('poster', posterUrl);
      videoEl.controls = false;

      // CRUCIAL: Set muted as both attribute and property
      videoEl.setAttribute('muted', true);
      videoEl.muted = true;

      const sourceEl = document.createElement('source');
      sourceEl.src = videoUrl;
      sourceEl.type = 'video/mp4';
      videoEl.appendChild(sourceEl);

      // Remove poster image
      const posterImg = wrapper.querySelector('.video-poster');
      if (posterImg) posterImg.remove();
        wrapper.appendChild(videoEl);

      videoEl.load();
      videoEl.play().catch((err) => {
        console.warn("Autoplay failed:", err);
      });
    }
         },1500);
  });

  // featured collection section -- for video

  const collectionSections = document.querySelectorAll(".featured-collection-wrapper");
  if(collectionSections.length){
    collectionSections.forEach((collectionSec)=>{
      const videoWrapper = collectionSec.querySelector(".video-box");
      console.log("videoWrapper",videoWrapper);
      if(videoWrapper){
        const videoUrl = videoWrapper.getAttribute('data-video-src');
        const posterUrl = videoWrapper.getAttribute('data-poster');
    
        if (videoUrl) {
          const videoEl = document.createElement('video');
    
          videoEl.setAttribute('loop', true);
          videoEl.setAttribute('autoplay', true);
          videoEl.setAttribute('playsinline', true);
          videoEl.setAttribute('preload', 'none');
          videoEl.setAttribute('poster', posterUrl);
          videoEl.controls = false;
    
          // Set muted as both attribute and property
          videoEl.setAttribute('muted', true);
          videoEl.muted = true;
    
          const sourceEl = document.createElement('source');
          sourceEl.src = videoUrl;
          sourceEl.type = 'video/mp4';
          videoEl.appendChild(sourceEl);
    
          // Remove poster image
          const posterImg = videoWrapper.querySelector('.video-poster');
          if (posterImg) posterImg.remove();
            videoWrapper.appendChild(videoEl);
    
          videoEl.load();
          videoEl.play().catch((err) => {
            console.warn("Autoplay failed:", err);
          });
        }
      }
    });
  }

});
